<template>
  <div class="main_box">
    <div class="main_bar" v-if="false">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <span class="currentSpan">人员职位查询</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
      <div>
        <el-button type="primary" @click="exportData()"> 导出数据 </el-button>
      </div>
    </div>
    <div class="main_body">
      <div class="form_bar">
        <div class="form_bar_search">
          <div class="condition_item">
            <el-input
              size="mini"
              placeholder="请输入关键字"
              v-model="listQuery.KeyWord"
              style="width: 260px"
              clearable
            >
              <el-button
                title="搜索"
                slot="append"
                icon="el-icon-search"
                @click="getMeetingReceiptAllList()"
              ></el-button>
            </el-input>
          </div>
        </div>
        <div class="form_bar_btn">
          <div class="condition_item">
            <el-button type="primary" @click="exportData()">
              导出数据
            </el-button>
          </div>
        </div>
      </div>
      <el-table
        v-loading="tableLoading"
        :data="meetingReceiptItems"
        style="width: 100%"
        stripe
        border
      >
        <el-table-column
          type="index"
          :index="indexMethod"
          label="序号"
          width="60"
          align="center"
        ></el-table-column>
        <el-table-column property="CompanyName" label="单位" min-width="260">
        </el-table-column>
        <el-table-column property="UserName" label="姓名" width="100">
        </el-table-column>
        <el-table-column property="Post" label="职务" min-width="100">
        </el-table-column>
        <!-- <el-table-column label="是否合住" width="100">
          <template slot-scope="scope">
            <div>
              <div v-if="scope.row.IsShare">
                合住
                <span v-if="scope.row.SharePeopleName">
                  （{{ scope.row.SharePeopleName }}）
                </span>
              </div>
              <div v-if="!scope.row.IsShare">单住</div>
            </div>
          </template>
        </el-table-column> -->
        <el-table-column property="Phone" label="电话" min-width="100">
        </el-table-column>
        <!-- <el-table-column
          property="FlightAndTrainNumber"
          label="航班车次"
          min-width="120"
        >
        </el-table-column> -->
        <!-- <el-table-column property="ArrivalTime" label="抵达时间" width="140">
          <template slot-scope="scope">
            {{ scope.row.ArrivalTime | dateformat('YYYY/MM/DD HH:mm') }}
          </template>
        </el-table-column> -->
        <!-- <el-table-column property="Remarks" label="备注" min-width="120">
        </el-table-column>
        <el-table-column label="取消参会" min-width="120">
          <template slot-scope="scope">
            <div>
              <div v-if="scope.row.CancelAttendance">是</div>
              <div v-if="!scope.row.CancelAttendance">否</div>
            </div>
          </template>
        </el-table-column> -->
      </el-table>
      <div class="pagination_box">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="listQuery.MaxResultCount"
          :layout="pagination_layout"
          :total="listTotalCount"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import meetingReceiptManagerApi from '../../../api/vote/meetingReceiptManager'
export default {
  name: 'MeetingReceipt',
  components: {

  },
  data () {
    return {
      meetingId: null,
      tableLoading: true,
      meetingReceiptItems: [],
      listTotalCount: 0,
      currentPage: 1,
      listQuery: {
        KeyWord: null,
        maxResultCount: 10,
        skipCount: 0
      },
      pagination_layout: 'prev, pager, next'
    }
  },
  props: ['meetingInfo'],
  methods: {
    getMeetingReceiptAllList: function () {
      this.tableLoading = true
      meetingReceiptManagerApi.getMeetingReceiptAllList(this.listQuery).then(data => {
        this.meetingReceiptItems = data.Items
        this.listTotalCount = data.TotalCount
        this.tableLoading = false
      }).catch(err => {
        this.tableLoading = false
        return err
      })
    },
    handleSizeChange (val) {
      this.listQuery.maxResultCount = val
      this.getMeetingReceiptAllList()
    },
    handleCurrentChange (val) {
      this.listQuery.skipCount = (val - 1) * this.listQuery.maxResultCount
      this.getMeetingReceiptAllList()
    },
    indexMethod (index) {
      return this.listQuery.skipCount + index + 1
    },
    exportData: function () {
      const openLoading = this.openLoading('正在导出…')
      meetingReceiptManagerApi.exportMeetingReceiptList({
        MeetingId: this.$route.params.mid
      }).then(data => {
        if (!data) {
          return
        }
        const fileName = this.meetingInfo.MeetingName + '参会回执信息汇总表'

        const fileUrl = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.ms-excel;charset=utf-8' }))

        const elink = document.createElement('a')
        // 设置下载文件名
        elink.setAttribute('download', fileName + '.xlsx')
        elink.style.display = 'none'
        elink.href = fileUrl
        document.body.appendChild(elink)
        elink.click()

        document.body.removeChild(elink) // 下载完成移除元素
        window.URL.revokeObjectURL(fileUrl) // 释放掉blob对象
        openLoading.close()
      }).catch(err => {
        openLoading.close()
        return err
      })
    },
    init: function () {
      this.getMeetingReceiptAllList()
    }
  },
  computed: {

  },
  created () {
    this.init()
    if (this.is_xs) {
      this.pagination_layout = 'total,prev, pager, next'
    } else {
      this.pagination_layout = 'total, sizes, prev, pager, next, jumper'
    }
  }
}
</script>
